
export default {
  name: 'ConfigurablePosition',
  values: {
    bottom: undefined,
    left: undefined,
    right: undefined,
    top: undefined,
  },
  meta: {
    extendable: false,
  },
}
